const React = require('react');
const {
  DEFAULT_AVATAR_CORP,
  USER_TYPE_MERCHANT,
  USER_TYPE_ADMIN, USER_TYPE_AUDITOR,
} = require('../../../../constants');
const {
  LINK_DASHBOARD,
  LINK_SETTINGS,
  LINK_ADMIN_SETTINGS, LINK_ADMIN_ACCOUNTS,
} = require('../../../../constants/links');
const {
  Link,
  pushLocation,
} = require('../../../../router');
const withState = require('../../../../utils/withState');
const {
  loadingReconnect$, apiAuthMerchantToAdmin,
} = require('../../../../api/_auth');
const {
  account$, getUserMainPage, loadingSignOut$, onAccount,
} = require('../../../../emitters/account');
const Loading = require('../../../dumb/Loading');
const Ripple = require('../../../dumb/Ripple');
const MenuAvatar = require('../../../dumb/Menu/Avatar');
const AppIcon = require('../../../icons/Lunu');
const Links = require('./Navigation');
const Cash = require('./Cash');
const BankInfo = require('./BankInfo');

const backToAdmin = () => {
  loadingSignOut$.emit(true);
  return apiAuthMerchantToAdmin()
    .then(onAccount)
    .then(() => {
      pushLocation({
        path: `${LINK_ADMIN_ACCOUNTS}`,
      });
    })
    .then(() => {
      setTimeout(() => {
        loadingSignOut$.emit(false);
      }, 500);
    })
}

module.exports = withState((props) => {
  return (state, props) => {
    const account = state.account || {};
    const accountType = account.account_type;
    const hasMerchant = accountType === USER_TYPE_MERCHANT;
    const hasAdmin = [USER_TYPE_ADMIN, USER_TYPE_AUDITOR].includes(accountType);

    const adminIsLogged = account.login_site !== 'default' && !!(account.login_site || {}).console;

    const signOutText = adminIsLogged
      ? 'to admin view'
      : 'Logout';
    const signOutFN = adminIsLogged
      ? backToAdmin
      : account$.signOut;


    return (
      <div className="hmin100vh bg3E4044 cF ovxH wmin1020 rlv f14">
        <div className="h100 abs sht layoutRow fhaB fvaC ph70">
          <div className="w(|min)330">
            <Link
              className="layoutRow fhaS fvaC tdN olN dn o70:h"
              href={getUserMainPage()}
            >
              <AppIcon className="w150 mr20 rlv st1 cF"/>
              <div className="f18 fw5 lh c717478">console</div>
            </Link>
          </div>
          <div className="layoutRow fhaB fvaC fx1 wmin600">
            <div className="layoutRow fhaS fvaC">
              {hasMerchant ? (<Cash/>) : null}
              {state.loadingReconnect ? (
                <div className="layoutRow fhaS fvaC pl15">
                  <div className="sq50 rlv">
                    <Loading/>
                  </div>
                  <div className="pl15">Reconnection...</div>
                </div>
              ) : null}
            </div>
            <div>
              <div className="mh-15">
                <MenuAvatar
                  items={[
                    {name: 'Settings', onClick() {
                      pushLocation({
                        path: hasAdmin ? LINK_ADMIN_SETTINGS : LINK_SETTINGS,
                      });
                    }},
                    {name: signOutText, onClick: signOutFN},
                  ]}
                  render={(props) => (
                    <Ripple
                      {...props}
                      className="layoutRow fhaE fvaC ph15 pv10 rlv ov r4
                        wmin200"
                    >
                      <div className="layoutRow fhaE fvaC wmin200">
                        <div className="pr22 wmax210">
                          <div
                            className="lh170% f14 tr fw5 cF"
                          >{account.company}</div>
                          <div className="rlv">
                            <div
                              className="abs sr st10 c7A7D83 lts-.01em fw5 f12"
                            >{accountType}</div>
                          </div>
                        </div>
                        <div className="sq(|min)50 rlv r ov">
                          <img
                            src={DEFAULT_AVATAR_CORP}
                            className="w50"
                          />
                        </div>
                      </div>
                    </Ripple>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        {hasMerchant ? (
          <div className="abs sl330 sr st110 ph70">
            <div className="layoutRow fhaB fvaS wmin600">
              <BankInfo
                className="cA4A7AC fw5 f16 ff$2 lh150%"
              />
            </div>
          </div>
        ) : <div/>}
        <div
          className={'abs shb st100 st200.merchant '
            + (hasMerchant ? ' merchant' : '')}
        >
          <div className="abs sl sb st st-100<1.merchant w330 ovxH ovyA
            pl70 pr10">
            <Links/>
          </div>
          <div className="abs sl330 svr ovxA ovyA ph70">
            {props.children || null}
          </div>
        </div>
      </div>
    );
  };
}, {
  loadingReconnect: loadingReconnect$,
  account: account$,
});
